module.exports = __webpack_public_path__ + "static/img/uluru.7e4ad3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/uluru.jpg
// module id = bJz5
// module chunks = 1